// /home/ananun/fluorescence.pro/admin/src/helpers/permissionsContext.js
// permissionsContext.js

import { useContext, createContext } from "react";

export const PermissionContext = createContext();

export function usePermissions() {
  return useContext(PermissionContext);
}
